<template>
  <v-container fluid class="pa-6">
    <DashboardFilters ref="dashboardFilters" :is-loading="isRefreshing" @draft-change="onFiltersDraftChange"
      @apply="onFiltersApply" @refresh="onFiltersRefresh" />

    <v-row class="mb-6">
      <v-col v-for="card in metricCardConfig" :key="card.key" cols="12" sm="6" md="4" lg>
        <MetricCard :title="card.title" :icon="card.icon" :icon-color="card.color" :metric-key="card.key"
          :metric-data="metrics[card.key]" :metric-status="metricStatus[card.key]"
          :is-comparison-active="isComparisonActive" :cards-loading="cardsLoading"
          :show-partial-activation="false"
          :supports-activation="card.supportsActivation" :activation-route="card.activationRoute"
          :value-formatter="card.valueFormatter" :comparison-value="filterValues.compare" />
      </v-col>
    </v-row>

    <DashboardGraph ref="dashboardGraph" :metrics="metrics" />
    <QuickStartPopup v-model="quickStart.show" :entry-mode="quickStartEntryMode" @close="onQuickStartClose" />

    <v-snackbar v-model="loadFailed" color="error" timeout="-1">
      Couldn't load your dashboard data.
      <template #actions>
        <v-btn variant="text" :loading="isRefreshing" @click="loadDashboard(filterValues)">Try Again</v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>

<script>
import dashboardMixin from '@/mixins/dashboard'
import DashboardFilters from './dashboard/DashboardFilters.vue'
import MetricCard from '@/components/dashboard/MetricCard.vue'
import DashboardGraph from '@/components/dashboard/DashboardGraph.vue'
import QuickStartPopup from '@/components/dashboard/QuickStartPopup'

export default {
  name: 'Dashboard',
  mixins: [dashboardMixin],
  components: {
    DashboardFilters,
    MetricCard,
    DashboardGraph,
    QuickStartPopup
  },
  data() {
    return {
      quickStart: {
        show: false
      }
    }
  },
  computed: {
    shouldShowQuickStart() {
      return !!this.user && !this.isAdmin && !this.user.quick_start_seen_at
    },
    quickStartEntryMode() {
      if (this.shouldShowQuickStart) {
        return 'full'
      }
      return this.$route.query.quickstart === 'video' ? 'video-only' : 'full'
    }
  },
  mounted() {
    if (this.shouldShowQuickStart || this.$route.query.quickstart) {
      this.quickStart.show = true
    }
  },
  methods: {
    onQuickStartClose() {
      this.quickStart.show = false
      if (this.$route.query.quickstart) {
        this.$router.replace({ query: {} })
      }
      if (!this.user?.quick_start_seen_at) {
        this.$store.dispatch('user/markQuickStartSeen', { userId: this.user.id })
      }
    }
  },
  watch: {
    '$route.query.quickstart'(val) {
      if (val) {
        this.quickStart.show = true
      }
    }
  }
}
</script>
